import { FaqSection } from './faq.model';

export const FAQ_SECTIONS: FaqSection[] = [
  {
    title: 'Using the App',
    items: [
      {
        question: 'How does HipTraveler help me plan my trip?',
        answer: 'HipTraveler combines AI-powered trip planning with insights from real travelers and local experts. You can explore destinations, filter by experiences and travel style, and instantly generate a personalized itinerary that feels both smart and authentic.'
      },
      {
        question: 'Can I save and edit my trips?',
        answer: 'Yes. Trips can be saved to your profile where you can update dates, swap activities, or mark a journey as a "Dream Trip" to revisit later. Everything is designed to be flexible and easy to update as your plans evolve.'
      },
      {
        question: 'Do I need to download the app to use HipTraveler?',
        answer: 'You can explore itineraries and content on the web, but downloading the HipTraveler app unlocks the full experience, including premium features, offline access, and seamless trip management.'
      }
    ]
  },
  {
    title: 'Premium Membership',
    items: [
      {
        question: "What's included in HipTraveler Premium?",
        answer: 'Premium gives you tools to travel smarter and with more support. Members enjoy global eSIM connectivity, direct access to our Travel Concierge for expert assistance, and the ability to export trips and itineraries to Google Maps for easy navigation.'
      },
      {
        question: 'How does the eSIM work?',
        answer: 'Once you book a trip through HipTraveler, we provide a digital eSIM profile with bundled data and minutes. This eliminates roaming charges and gives you instant, reliable service when you arrive at your destination.'
      },
      {
        question: 'What is the Travel Concierge?',
        answer: "The Travel Concierge connects you with real travel agents who can help with more complex itineraries, special requests, and personal recommendations. It's the perfect blend of technology and human expertise."
      },
      {
        question: 'Can I export trips to Google Maps?',
        answer: 'Yes. Premium members can export itineraries directly to Google Maps for turn-by-turn navigation, making it effortless to follow your plans on the go.'
      }
    ]
  },
  {
    title: 'Travelogging & Content',
    items: [
      {
        question: 'What is Travelogging?',
        answer: "Travelogging is HipTraveler's way of helping you capture, preserve, and relive your adventures. You can write travelogues, save photos and videos, and create collections of favorite hacks and memories—all stored neatly in your profile."
      },
      {
        question: 'Can I share my Travelogues with others?',
        answer: 'Yes. You can publish Travelogues to inspire the community or keep them private for personal reflection. Travelogues can also be exported into travel blogs, including WordPress, if you want to share them on your own site.'
      },
      {
        question: 'What are Dream Trips?',
        answer: "Dream Trips are future journeys you've highlighted in your profile. Mark any trip as a Dream Trip to revisit later or use it as inspiration when you're ready to book."
      }
    ]
  },
  {
    title: 'Booking & Payments',
    items: [
      {
        question: 'Is it safe to book through HipTraveler?',
        answer: 'Absolutely. We use secure payment processing and never share your personal financial details. Your data is protected, and our system is designed for reliability and transparency.'
      },
      {
        question: "What is HipTraveler's cancellation policy?",
        answer: "Our cancellation and refund policies depend on the hotel, tour operator, or airline you book through. Each trip displays the applicable terms before checkout, so you'll always know what to expect."
      },
      {
        question: 'How do I request a refund?',
        answer: "Refund requests can be submitted directly through your HipTraveler account. We'll coordinate with the provider and keep you updated throughout the process."
      }
    ]
  },
  {
    title: 'Software Support & Bug Resolution',
    items: [
      {
        question: 'How can I report a technical issue or bug?',
        answer: 'If you encounter an issue—be it a crash, unexpected behavior, or incorrect data—head to the Support section in your profile and use our bug report form. Please include relevant screenshots, device type, OS version, and what you were doing when the issue occurred to help us diagnose and resolve it quickly.'
      },
      {
        question: "What happens after I report a bug?",
        answer: "Once submitted, your report is triaged by our support team and passed to Engineering if needed. You'll receive a confirmation, access to the status updates via your account dashboard, and a notification once the issue is fixed."
      },
      {
        question: 'How long does it take to resolve bugs?',
        answer: 'Resolution times vary. Minor issues and typos may be fixed in a few days; more complex bugs (e.g., with third-party integrations) may take longer. We aim to update you with an estimated timeline within 48 hours of your report.'
      },
      {
        question: 'What if I encounter an integration issue (e.g., with booking providers or Google Maps export)?',
        answer: 'Integration bugs—like failures syncing with third-party services or export errors—are logged as high-priority. Our team works closely with partners to isolate the problem and implement a fix as swiftly as possible.'
      },
      {
        question: 'Can I track known issues?',
        answer: 'Yes. HipTraveler maintains a public-facing status page and bug tracker where you can view known issues, current status, and recent fixes.'
      }
    ]
  }
];
